import { render } from "./Tips.vue?vue&type=template&id=6d5bfc0f&scoped=true"
import script from "./Tips.vue?vue&type=script&lang=js"
export * from "./Tips.vue?vue&type=script&lang=js"

import "./Tips.vue?vue&type=style&index=0&id=6d5bfc0f&lang=scss"
import "./Tips.vue?vue&type=style&index=1&id=6d5bfc0f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d5bfc0f"]])

export default __exports__